import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import networkHandler from "../../network/networkHandler";
import { EApiMiddlewareMethods } from "../../network/networkHandler.types";
import AppConstants from "../../constants";
import { PODState } from "./PODSlice.types";

export const fetchPOD = createAsyncThunk(
    "POD/FetchPOD",
    async (
      {
        params,
        type,
      }: {
        params: any;
        type?: string;
      },
      { rejectWithValue }
    ) => {
      try {
        const url = `delivery-receipt/download?consignmentCode=${params}`;
        let data;
        if (type === "std") {
          ({ data } = await networkHandler({ url, method: EApiMiddlewareMethods.GET }, { isAuth: true, isUAE: true }));
        } else {
          ({ data } = await networkHandler({ url, method: EApiMiddlewareMethods.GET }, { isAuth: true, isExpress: true }));
        }
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || { message: error.message });
      }
    }
  );

const initialState: PODState = {
  loading: false,
  error: "",
  errorCode: "",
  PODImages: [],
  PODSign: ""
};

const PODSlice = createSlice({
  name: "POD",
  initialState,
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchPOD.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.errorCode = "";
        state.PODImages = [];
        state.PODSign = "";
      })
      .addCase(fetchPOD.fulfilled, (state, action) => {
        const payload = action.payload;
        state.loading = false;
        state.error = "";
        state.errorCode = "";
        state.PODImages = payload?.results?.IMAGES || [];
        state.PODSign = payload?.results?.SIGN || "";
      })
      .addCase(fetchPOD.rejected, (state, action) => {
        const errorPayload: any = action.payload;
        state.loading = false;
        state.errorCode = errorPayload?.error || AppConstants.RESPONSE_CONSTANTS.ERROR_CODES.DEFAULT_API_FAILED;
        state.error = errorPayload?.message || AppConstants.RESPONSE_CONSTANTS.DEFAULT_API_FAILED_ERROR_MSG;
      });
  },
});

export default PODSlice.reducer;
